import { ref } from '@nuxtjs/composition-api';
const modalPickUp = ref(false);

export default function useEmitter() {
  const openModalPickUp = () => {
    modalPickUp.value = !modalPickUp.value;
  };

  return {
    modalPickUp,
    openModalPickUp
  };
}
